import { useCallback, useEffect, useRef } from "react";

export const useMetaPixel = () => {
  const hasHydratedRef = useRef(false);

  useEffect(() => {
    if (hasHydratedRef.current) {
      return;
    }

    hasHydratedRef.current = true;

    const storedConsent = localStorage.getItem("cookie_consent");

    if (storedConsent === "true") {
      if (typeof window.fbq === "function") {
        window.fbq("consent", "grant");
        window.fbq("track", "PageView");
      }
    }
  }, []);

  const acceptConsent = useCallback(() => {
    localStorage.setItem("cookie_consent", "true");

    if (typeof window.fbq === "function") {
      window.fbq("consent", "grant");
      window.fbq("track", "PageView");
    }
  }, []);

  const declineConsent = useCallback(() => {
    localStorage.setItem("cookie_consent", "false");

    if (typeof window.fbq === "function") {
      window.fbq("consent", "revoke");
    }
  }, []);

  return { acceptConsent, declineConsent };
};
